import {gtmProductClick} from './gtmProductClick';
import {
    GTM_ATTRIBUTE_PREDICTIVE_SEARCH_ARTICLES_COUNT,
    GTM_ATTRIBUTE_PREDICTIVE_SEARCH_COLLECTIONS_COUNT,
    GTM_ATTRIBUTE_PREDICTIVE_SEARCH_PRODUCTS_COUNT,
    GTM_SELECTOR_PREDICTIVE_SEARCH_CLICK,
    GTM_ATTRIBUTE_PREDICTIVE_SEARCH_CLICK,
    GTM_SELECTOR_PREDICTIVE_SEARCH_ITEM_NAME,
    GTM_ATTRIBUTE_PREDICTIVE_SEARCH_ITEM_NAME,
} from './gtmSelectors';

export const gtmSuggestResult = (queryKeyValue, selector) => {
    if (queryKeyValue.length > 2) {
        const articlesCount = Number(selector?.getAttribute(GTM_ATTRIBUTE_PREDICTIVE_SEARCH_ARTICLES_COUNT));
        const collectionsCount = Number(selector?.getAttribute(GTM_ATTRIBUTE_PREDICTIVE_SEARCH_COLLECTIONS_COUNT));
        const productsCount = Number(selector?.getAttribute(GTM_ATTRIBUTE_PREDICTIVE_SEARCH_PRODUCTS_COUNT));

        window.dataLayer.push({
            'event': 'ec.suggest_result',
            'suggestResult': {
                'keyword': queryKeyValue,
                'results': articlesCount + collectionsCount + productsCount,
                'sections': {
                    'categories': collectionsCount,
                    'products': productsCount,
                    'articles': articlesCount,
                },
            },
        });

        const predictiveSearchLinks = selector.querySelectorAll(GTM_SELECTOR_PREDICTIVE_SEARCH_CLICK);
        predictiveSearchLinks.forEach((link) => {
            const type = link?.getAttribute(GTM_ATTRIBUTE_PREDICTIVE_SEARCH_CLICK);
            const title = link.querySelector(GTM_SELECTOR_PREDICTIVE_SEARCH_ITEM_NAME)
                ?.getAttribute(GTM_ATTRIBUTE_PREDICTIVE_SEARCH_ITEM_NAME);

            if (type == 'product') {
                link.addEventListener('auxclick', () => {
                    gtmProductClick(link, title, 'suggest');
                });

                link.addEventListener('click', () => {
                    gtmProductClick(link, title, 'suggest');
                });

                return;
            }

            link.addEventListener('auxclick', () => {
                gtmSuggestClick(type, title, queryKeyValue);
            });

            link.addEventListener('click', () => {
                gtmSuggestClick(type, title, queryKeyValue);
            });
        });
    }
};

const gtmSuggestClick = (type, title, queryKeyValue) => {
    window.dataLayer.push({
        'event': 'ec.suggest_click',
        'suggestClick': {
            'section': type,
            'itemName': title,
            'keyword': queryKeyValue,
        },
    });
};
